<template>
  <div>
    <div class="d-flex align-center justify-space-between ga-3">
      <div>
        <div class="font-weight-bold font-size-15">
          Доступи до типу документа
        </div>
        <div class="text-disabled">
          Надайте доступ підрозділам або співробітникам
        </div>
      </div>

      <v-btn @click="accessCreate">
        <v-icon class="mr-2" icon="mdi-plus"></v-icon>
        <span>Додати</span>
      </v-btn>
    </div>

    <v-data-table
      :headers="docTypeAccessListHeaders"
      :items="docTypeSource.accesses">
      <template #item.entity="{ item }">
        <span v-if="item.userId">
          {{ getPersonName(item.user) }}
        </span>
        <span v-if="item.departmentId">
          {{ item.department?.name }}
        </span>
      </template>

      <template #item.actions="{ item }">
        <v-btn
          variant="outlined"
          color="error"
          density="comfortable"
          @click="accessDelete(item.id)">
          Видалити
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script setup lang="ts">
import { useDocType } from '../../docType'
import { docTypeAccessListHeaders } from '@/utils/tableHeaders'
import { getPersonName } from 'best-modules/utils'

defineOptions({
  name: 'Accesses',
})

const { docTypeSource, accessCreate, accessDelete } = useDocType()
</script>
